// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1PCa2","head":"ProcedureTableInfo_head__3yRXQ"};